$(function () {
  if ($('.js-homeground-map').length > 0) {

    const BASE_PATH = 'assets/images/homeground/';

    const initHomeground = ($component) => {
      const $leaderboardList = $component.find('.js-leaderboard-list');
      const $scoreCards = $leaderboardList.find('.js-score-card');
      const $mapImage = $component.find('.js-map-image');
      const $mapBackground  = $component.find('.js-map-background');
      const $mapPieces = $component.find('.js-map-piece');
      const $mapLogos = $component.find('.js-map-logo');

      const setAllCardsActive = () => {
        $scoreCards
          .removeClass('is-dimmed')
          .addClass('is-active');
      };

      const setHoveredCard = ($hoveredCard) => {
        $scoreCards
          .removeClass('is-active')
          .addClass('is-dimmed');
        $hoveredCard
          .removeClass('is-dimmed')
          .addClass('is-active');
      };

      const swapMapImage = (src) => {
        $mapImage
          .css('opacity', 0)
          .attr('src', src)
          .off('load.homeground')
          .on('load.homeground', function () {
            $(this).css('opacity', 0.9);
          });
        if ($mapImage[0].complete) {
          $mapImage.css('opacity', 0.9);
        }
      };

      const swapMapBackground = (src) => {
        $mapBackground.attr('src', src)
      };

      const resetMapImage = () => {
        swapMapImage($mapImage.data('default-map'));
        swapMapBackground($mapBackground.data('default-bg'));
      };

      const showPiece = (region) => {
        $mapPieces.removeClass('is-active');
        $mapPieces.addClass('is-dimmed');
        $mapPieces
          .filter(`[data-region="${region}"]`)
          .removeClass('is-dimmed')
          .addClass('is-active');
      };

      const hideAllPieces = () => {
        $mapPieces.removeClass('is-active');
        $mapPieces.removeClass('is-dimmed');
      };

      const activateLogo = (region) => {
        $mapLogos.each(function () {
          const $logo = $(this);
          const logoRegion = $logo.data('region');
          if (logoRegion === region) {
            $logo.attr('src', `${BASE_PATH}logo/logo-${logoRegion}.png`);
            $logo.removeClass('is-dimmed');
          } else {
            $logo.attr('src', `${BASE_PATH}logo/logo-${logoRegion}-idle.png`);
            $logo.addClass('is-dimmed');
          }
        });
      };

      const resetLogos = () => {
        $mapLogos.each(function () {
          const $logo = $(this);
          const logoRegion = $logo.data('region');
          $logo.attr('src', `${BASE_PATH}logo/logo-${logoRegion}-idle.png`);
          $logo.removeClass('is-dimmed');
        });
      };

      const activateRegion = (region) => {
        swapMapImage(`${BASE_PATH}map-on-full/map-${region}.svg`);
        swapMapBackground(`${BASE_PATH}bg-full-map/bg-active-${region}.png`);
        showPiece(region);
        activateLogo(region);
      };

      const deactivateRegion = () => {
        resetMapImage();
        hideAllPieces();
        resetLogos();
      };

      setAllCardsActive();

      $scoreCards.on('mouseenter', function () {
        const region = $(this).data('region');
        setHoveredCard($(this));
        activateRegion(region);
      });

      $leaderboardList.on('mouseleave', function () {
        setAllCardsActive();
        deactivateRegion();
      });

      $mapLogos.on('mouseenter', function () {
        const region = $(this).data('region');

        const $matchingCard = $scoreCards.filter(`[data-region="${region}"]`);
        setHoveredCard($matchingCard);

        activateRegion(region);
      });

      $mapLogos.on('mouseleave', function () {
        setAllCardsActive();
        deactivateRegion();
      });

      $component.find('.section-homeground__map-container').on('mouseleave', function () {
        setAllCardsActive();
        deactivateRegion();
      });
    };

    $(document).ready(function () {
      $('.js-homeground-map').each(function () {
        initHomeground($(this));
      });
    });
  }
});
